import { render, staticRenderFns } from "./public-spell.vue?vue&type=template&id=4ed34674&scoped=true&"
import script from "./public-spell.vue?vue&type=script&lang=js&"
export * from "./public-spell.vue?vue&type=script&lang=js&"
import style0 from "./public-spell.vue?vue&type=style&index=0&id=4ed34674&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed34674",
  null
  
)

export default component.exports